import { render, staticRenderFns } from "./ReferralHistory.vue?vue&type=template&id=4a5e2b4a&scoped=true"
import script from "./ReferralHistory.vue?vue&type=script&lang=js"
export * from "./ReferralHistory.vue?vue&type=script&lang=js"
import style0 from "./ReferralHistory.vue?vue&type=style&index=0&id=4a5e2b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e2b4a",
  null
  
)

export default component.exports